import { defineRecipe } from '@chakra-ui/react';

// Same drift as input.ts. lineHeight matters more here: textStyle md carries
// 24px but v2's baseStyle was `short` (22px), so without it every wrapped line
// sits 2px further apart. Vertical padding already matches.
//
// Focus (DEV-2095): unlike stock input, stock textarea's outline variant never
// routes its ring through --focus-color, so the focused border and ring take
// colorPalette.focusRing: gray.400 under html's default gray palette, which
// reads as black. v2 used blue.500, as for Input. colorPalette="primary" is no
// way out, the portal emits no primary.focusRing token. _invalid as in
// input.ts.
const textareaRecipe = defineRecipe({
  base: {
    '--focus-color': 'colors.primary.500',
    _invalid: {
      focusRingColor: 'var(--focus-color)',
    },
  },
  variants: {
    variant: {
      outline: {
        focusRingColor: 'var(--focus-color)',
        _invalid: { outline: '1px solid var(--error-color)' },
      },
    },
    size: {
      md: { textStyle: 'md', lineHeight: 'short', px: '4', borderRadius: 'md' },
    },
  },
});

export default textareaRecipe;
